<template>
    <div>
        <SidebarNavigation>
            <div class="container px-4 md:px-12 pt-2 pb-10 mx-auto max-w-7xl">
                <h1 class="text-gray-600 font-semibold mb-5 text-xl">Cetak Resi</h1>
                <div class="flex items-center justify-between mb-6">
                    <div class="lg:w-1/2 w-full">
                        <input v-model="search" @input="tableInputSearchHandler($event)" type="text" class="border border-gray-400 px-3 py-2 text-sm rounded-md lg:w-1/2 w-full" placeholder="Pencarian.." />
                    </div>
                </div>
                <datatable
                    :data="data.data"
                    :columns="columns"
                    :meta="data.meta"
                    :PageNavHandler="pageNavHandler"
                    :TableInputSearchHandler="tableInputSearchHandler"
                >
                    <!-- Custom Field -->
                    <template slot="createdAt" slot-scope="props">
                        {{ formatDate(props.item.createdAt) }}
                    </template>
                    <template slot="action" slot-scope="props">
                        <div class="flex items-center">
                            <zdropdown text="Print Resi">
                                <template v-slot:item>
                                    <div class="max-w-sm">
                                        <button @click="$router.push('/print/resi/' + props.item.id + '?type=IDR')" class="hover:text-gray-700 px-3 py-2 text-sm text-gray-600 focus:outline-none flex items-center mr-2" style="font-size: 11px">
                                            <svg class="w-4 h-4 mr-2 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                                                <path fill-rule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clip-rule="evenodd" />
                                            </svg>
                                            <h4 class="font-semibold">Mata Uang IDR</h4>
                                        </button>
                                        <hr/>
                                        <button @click="$router.push('/print/resi/' + props.item.id + '?type=USD')" class="hover:text-gray-700 px-3 py-2 text-sm text-gray-600 focus:outline-none flex items-center mr-2" style="font-size: 11px">
                                            <svg class="w-4 h-4 mr-2 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                                                <path fill-rule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clip-rule="evenodd" />
                                            </svg>
                                            <h4 class="font-semibold">Mata Uang USD</h4>
                                        </button>
                                    </div>
                                </template>
                            </zdropdown>
                        </div>
                    </template>
                    <!-- / End Custom Field -->
                </datatable>
            </div>
        </SidebarNavigation>
    </div>
</template>

<script>
import SidebarNavigation from '@/components/SidebarNavigation';
import datatable from '@/components/datatables/advance_table';
import zdropdown from '@/components/zdropdown';
import axios from 'axios';
import { api_url } from '@/config/api';

export default {
    components: { 
        SidebarNavigation,
        datatable,
        zdropdown
    },
    data() {
        return {
            /* Auth Token */
            headers: JSON.parse(window.sessionStorage.getItem('token-auth-jaskipin-agen')),
            /* Data List */
            data: [],
            columns: [{
                field: 'shipment_number',
                label: 'No Order'
            },{
                field: 'sender_name',
                label: 'Nama Pengirim'
            },{
                field: 'recipient_name',
                label: 'Nama Penerima'
            },{
                field: 'recipient_phone',
                label: 'No Handphone Penerima'
            },{
                field: 'createdAt',
                label: 'Tanggal Order'
            },{
                field: 'action',
                label: 'Aksi'
            }],
            /* Pagination */
            page: 1,
            limit: 10,
            /* Filter */
            search: '',
            /* Toggle Dialog */
            /* Form Value */
            /* Extra Data */
        }
    },
    computed: {
        profileData() {
            let profile = JSON.parse(window.sessionStorage.getItem('data-profile-jaskipin-agen'));
            if(profile) {
                return profile;
            }else{
                return null;
            }
        }
    },
    created() {
        /* Initiate Function */
        this.getListData(this.page, this.limit);
    },
    methods: {
        /*
         * Get Data Method
         */
        async getListData(page, limit) {
            let query_params = {
                page: page,
                limit: limit,
                pagination: true,
                search: this.search,
                filter_shipment_number: true
            }

            try {
                const response = await axios.get(`${api_url}/api/v1/transaction/international-order/get-filter-agen/${this.profileData.id}`, { params: query_params, headers: this.headers });
                console.log(response);
                this.data = response.data;
            }catch (error) {
                console.log(error);
                if(error.message.includes('404') || error.message.includes('500')){
                    // Destroy Data Auth in LocalStorage
                    window.sessionStorage.removeItem('token-auth-jaskipin-agen');
                    window.sessionStorage.removeItem('data-profile-jaskipin-agen');
                    // Redirect to Login Page
                    this.$router.push('/');
                }
            }
        },
        /*
         * Pagination Handler Function
         */
        pageNavHandler (type) {
            switch (type) {
                case 'previous':
                    this.page -= 1;
                    this.getListData(this.page, this.limit);
                break;
                case 'next':
                    this.page += 1;
                    this.getListData(this.page, this.limit);
                break;
            }
        },
        /*
         * Search Function
         */
        tableInputSearchHandler(event) {
            const value = event.target.value; // ambil value dari form input search

            if (value === '') {
                this.search = ''; // Mengkosongkan kembali state querynya
                this.getListData(this.page, this.limit);
            } else {
                this.search = value;
                this.getListData(1, this.limit); // Ketika Filter Search dilakukan tidak bisa jika diset pagenya diatas 1 kalau hasil recordnya gak lebih dari limit/10 record
            }
        },
        /* Helpers */
        formatPrice(number) {
            var rupiah = '';		
            var angkarev = number.toString().split('').reverse().join('');
            for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
            return rupiah.split('',rupiah.length-1).reverse().join('');
        },
        formatDate(value) {
            let options = { year: 'numeric', month: 'long', day: 'numeric' };
            let date = new Date(value).toLocaleString('id-ID', options);
            return date;
        }
    }
}
</script>

<style scoped>

</style>